import { render, staticRenderFns } from "./math-answer.vue?vue&type=template&id=66c6384f&scoped=true&"
import script from "../../assets/js/exam/math-answer.js?vue&type=script&lang=js&"
export * from "../../assets/js/exam/math-answer.js?vue&type=script&lang=js&"
import style0 from "../../assets/css/exam.css?vue&type=style&index=0&id=66c6384f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c6384f",
  null
  
)

export default component.exports